<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">{{'Add New Inspection' | translate | async}}</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>

    <div class="dialog-content">
        <!-- <div class="center">
            <mat-spinner></mat-spinner>
        </div> -->
        <ng-container>
            <div class="search-options search-mat-column">
                <mat-form-field class="search-input"> 
                    <input type="text" [placeholder]="'Select Customer' | translate | async" (input)="customerChanged($event)"
                        matInput [matAutocomplete]="auto2" [(ngModel)]="Customer" name="customrer" required>
                    <mat-autocomplete [(ngModel)]="Customer" #model_auto="ngModel" #auto2="matAutocomplete"
                        (optionSelected)="onSelectCustomer($event.option)">
                        <mat-option [value]="customer.Title"
                            *ngFor="let customer of _dropDownListsFiltered.customerList">
                            {{ customer.Title}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>


                <mat-form-field class="search-input">
                    <mat-select (selectionChange)="jobsiteChanged($event)" [(ngModel)]="Jobsite" name="jobsite1"
                        [placeholder]="'Select Job Site' | translate | async" required>
                        <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                            {{ jobsite.Title }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="search-input">  
                    <input type="text" matInput [placeholder]="'Select Asset' | translate | async" [(ngModel)]="selectedImp"
                        [matAutocomplete]="autoModel" (input)="filterUnitNumbers($event.target.value)" name="asset"
                        required>
                    <mat-autocomplete #autoModel="matAutocomplete"
                        (optionSelected)="selectUnitNumber($event.option.value)">
                        <mat-option *ngFor="let imp of implementListFiltered" [value]="imp.Id">
                            {{ imp.Name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="search-input">
                    <input matInput #start_Date="ngModel" [(ngModel)]="selected_date" [matDatepicker]="picker"
                        [placeholder]="'Choose a date' | translate | async" (dateChange)="getDate($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <mat-form-field class="search-input">
                    <input matInput type="number" [placeholder]="'SMU' | translate | async" [(ngModel)]="smu" [min]="preSmu" required (input)="onSMUChange()" />
                    <span matSuffix>Hrs</span>
                </mat-form-field>

                <!-- <div class="search-input">
                    <span class="label">Date</span>
                    <span class="input-icon input-icon--mat cursor-pointer" (click)="picker.open()"
                        matTooltip="{{ttDate}}">
                        <i class="material-icons">date_range</i>
                    </span>
                    <input type="text" [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                        placeholder="Select a Date" [(ngModel)]="inspectionDate" readonly="readonly"
                        style="color: black; max-width: 52%; min-width: 50%;">
                    <mat-datepicker #picker></mat-datepicker>
                </div>

                <div class="search-input">
                    <span class="label">SMU</span>
                    <input type="number" value="0.00" min="0" [(ngModel)]="smu" [formControl]="smuReadingInput"
                        min="preSmu" ngDefaultControl required />
                    <span class="input-icon">Hrs</span>
                </div>
                <div *ngIf="smuReadingInput.errors && (smuReadingInput.dirty || smuReadingInput.touched)">
                    <mat-error *ngIf="smuReadingInput.errors.required">SMU Reading is required</mat-error>
                    <mat-error *ngIf="smuReadingInput.errors.min"> SMU must be greater than previous SMU</mat-error>
                </div> -->
            </div>
        </ng-container>
    </div>
</div>

<div class="ttmodal__footer">
    <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">{{'Cancel' | translate | async}}</span></a>
    <!-- <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span
              class="button__text">Save</span></a> -->
    <button mat-raised-button color="warn" (click)="createNewInspection()" [disabled]="submitted"  [class.loading]="isLoading" >
        <!-- <span class="material-icons button__icon">check</span> -->
        <span class="button__text">{{'Start Inspection' | translate | async}}</span>
    </button>
</div>